import { useEffect, useRef } from "react";

const DEFAULT_OPTIONS = { threshold: 0.15 };

// Adds `is-visible` to the element when it scrolls into view.
export default function useReveal(options = DEFAULT_OPTIONS) {
    const ref = useRef(null);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const prefersReduced = window.matchMedia(
            "(prefers-reduced-motion: reduce)"
        ).matches;
        if (prefersReduced) {
            el.classList.add("is-visible");
            return;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            options
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [options]);
    return ref;
}
